/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    LoaTrust,
    LoaTrustFromJSON,
    LoaTrustToJSON,
} from '../models';

export interface SaveRequest {
    loaTrust: LoaTrust;
}

/**
 * 
 */
export class LoaRestControllerApi extends runtime.BaseAPI {

    /**
     */
    async getLoaTrustsRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<LoaTrust>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/loa/loa-trusts`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(LoaTrustFromJSON));
    }

    /**
     */
    async getLoaTrusts(initOverrides?: RequestInit): Promise<Array<LoaTrust>> {
        const response = await this.getLoaTrustsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async saveRaw(requestParameters: SaveRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.loaTrust === null || requestParameters.loaTrust === undefined) {
            throw new runtime.RequiredError('loaTrust','Required parameter requestParameters.loaTrust was null or undefined when calling save.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/loa/save-loa`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LoaTrustToJSON(requestParameters.loaTrust),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async save(loaTrust: LoaTrust, initOverrides?: RequestInit): Promise<void> {
        await this.saveRaw({ loaTrust: loaTrust }, initOverrides);
    }

}
